import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import type { CustomerNewsletterSubscriptionRequest } from './model/CustomerNewsletterSubscriptionRequest';
import type { CustomerNewsletterSubscriptionResponse } from './model/CustomerNewsletterSubscriptionResponse';

export const useCustomerNewsletterSubscription = (): UseMutationResult<
    CustomerNewsletterSubscriptionResponse,
    unknown,
    CustomerNewsletterSubscriptionRequest
> =>
    useBffPostMutation<
        CustomerNewsletterSubscriptionResponse,
        CustomerNewsletterSubscriptionRequest
    >('/customers/newsletter-subscription');
